import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'


export default function useCustomersTableFilters() {

    const data = useSignal([])
    const isLoading = useSignal(false)

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            isLoading.value = true
            postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/context`, commonFiltersValue.value)
                .then(res => {
                    data.value = res
                    isLoading.value = false
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value,
        isLoading: isLoading.value
    }
}